//React imports
import React from 'react';

//MUI Imports
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { getNames } from '../../services/stacks';
import { getUserData } from '../../services/auth';
import { clientNetwork } from '../../lib/constants';

const UploadAttachmentComponent = ({ btnDisable, open,
    // setShowBnsWarningModal 
}) => {
    //Handles BNS ownership validations
    async function upload() {
        // getNames(getUserData().profile.stxAddress.testnet).then(({ success }) => {
        //getNames(getUserData().profile.stxAddress.mainnet).then(({ success }) => {
        // if (success) {
        open();
        // } else {
        //     setShowBnsWarningModal(true);
        // }
        // })
    }

    return (
        <Tooltip title="Add Attachment: JPG, PNG, GIF, MP3, WAV, or MP4 and no larger than 20mb">
            <IconButton onClick={upload} disabled={btnDisable} id="attachment-icon" aria-label="Upload Audio" component="label">
                <AttachFileIcon size={24} />
            </IconButton>
        </Tooltip>
    );
}

export default UploadAttachmentComponent;
